<header class="header-content" [class.ps-0]="!sideNavigationService.isLeftMenuOpen">
    <nav class="navbar navbar-light">
        <button
            class="navbar-toggler"
            type="button"
            (click)="sideNavigationService.toggleSidebar()"
            [attr.aria-label]="'Toggle sidebar' | translate">
            <span class="navbar-toggler-icon" aria-hidden="true"></span>
        </button>
        <div class="navbar-brand">
            <img [src]="portal.logoUrl" [alt]="'portal logo' | translate" style="max-height: 40px; max-width: 80px" />
        </div>
    </nav>
</header>

<div class="wrapper">
    <sb-sidenav class="left-panel">
        <app-left-panel
            [communityDisplayName]="portal.communityDisplayName"
            (closeClick)="sideNavigationService.toggleSidebar()">
        </app-left-panel>
    </sb-sidenav>
    <main>
        <div class="content-container" [class.ps-0]="!sideNavigationService.isLeftMenuOpen">
            <div class="p-3">
                <h2 class="text-center mb-4">
                    <i class="fa-solid fa-shield-halved" aria-hidden="true"></i>
                    {{ 'Right of Access Request' | translate }}
                </h2>
                @if (!isRequestSubmitted && !request.authUserInfo.isAuthDataSubmitted) {
                    <div style="max-width: 800px">
                        @if (portal.statement) {
                            <p [innerHTML]="portal.statement"></p>
                        } @else {
                            <p>
                                {{ 'This is the text from the settings page, where' | translate }}
                                {{ portal.communityDisplayName }}
                                {{ 'explains the process of what happens to this request.' | translate }}
                            </p>
                        }

                        <p>
                            {{ 'Please follow these steps to request your data:' | translate }}
                        </p>
                        <ul class="numbered-list">
                            <li>
                                {{
                                    'Authenticate with each of the channels in which you had a dialog with' | translate
                                }}
                                {{ portal.communityDisplayName }}
                                :
                                <div class="mt-3">
                                    <div class="flex-row flex-row_with-social-btn flex-row_centered-text">
                                        <button class="btn btn-social btn-facebook" (click)="loginWithFacebook()">
                                            <i class="social-icon fa-brands fa-facebook-square" aria-hidden="true"></i>
                                            {{ 'Connect with Facebook' | translate }}
                                        </button>
                                        @if (request.authUserInfo.facebookId) {
                                            <span class="ms-3">{{ 'Authenticated' | translate }}</span>
                                        } @else {
                                            <span class="ms-3">{{ 'Not authenticated yet' | translate }}</span>
                                        }
                                    </div>

                                    <div class="flex-row flex-row_with-social-btn flex-row_centered-text mt-2">
                                        <a
                                            class="btn btn-social btn-instagram"
                                            href="https://api.instagram.com/oauth/authorize/?client_id=8d0565ea316d4b2ab620c5de8ae494e1&redirect_uri={{
                                                instagramRedirectUri
                                            }}&response_type=code">
                                            <i class="social-icon fa-brands fa-instagram" aria-hidden="true"></i>
                                            {{ 'Connect with Instagram' | translate }}
                                        </a>
                                        @if (request.authUserInfo.instagramId) {
                                            <span class="ms-3">{{ 'Authenticated' | translate }}</span>
                                        } @else {
                                            <span class="ms-3">{{ 'Not authenticated yet' | translate }}</span>
                                        }
                                    </div>

                                    <div class="flex-row flex-row_with-social-btn flex-row_centered-text mt-2">
                                        <a class="btn btn-social btn-youtube" href="{{ youtubeConnectLink }}">
                                            <span class="social-icon youtube-icon" aria-hidden="true"></span>
                                            {{ 'Connect with YouTube' | translate }}
                                        </a>
                                        @if (request.authUserInfo.youtubeId) {
                                            <span class="ms-3">{{ 'Authenticated' | translate }}</span>
                                        } @else {
                                            <span class="ms-3">{{ 'Not authenticated yet' | translate }}</span>
                                        }
                                    </div>
                                </div>

                                <div class="email-support-block mt-3">
                                    <div class="email-support-block__left-subblock">
                                        <i class="fa-regular fa-envelope" aria-hidden="true"></i>
                                    </div>
                                    <div class="email-support-block__right-subblock">
                                        <label for="newEmail">
                                            <b>{{ 'Email support' | translate }}</b>
                                        </label>
                                        <p>
                                            {{
                                                'You must enter the email address you have used communicating with'
                                                    | translate
                                            }}
                                            {{ portal.communityDisplayName }} .
                                            {{
                                                "To ensure that this email belongs to you, we will send you a code that must be verified in the next step. You can verify more than one email address if you'd like."
                                                    | translate
                                            }}
                                        </p>

                                        <form
                                            class="d-flex align-items-baseline m-flex-column mt-4"
                                            #newEmailForm="ngForm">
                                            <div class="form-group me-3 mb-2">
                                                <input
                                                    type="email"
                                                    class="form-control"
                                                    #newEmailModel="ngModel"
                                                    id="newEmail"
                                                    placeholder="{{ 'Enter your email' | translate }}"
                                                    name="newEmail"
                                                    [(ngModel)]="newEmail"
                                                    required
                                                    email />
                                            </div>
                                            <button
                                                type="submit"
                                                class="btn"
                                                [disabled]="!newEmailForm.form.valid"
                                                (click)="addEmail()"
                                                [disabled]="isAddingNewEmail">
                                                {{ 'Send code' | translate }}
                                            </button>
                                        </form>

                                        @if (newEmail && isNewEmailAdded) {
                                            <form class="d-flex align-items-baseline m-flex-column">
                                                <div class="form-group mt-2 me-3 mb-2">
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id="newEmailCode"
                                                        autocomplete="off"
                                                        placeholder="{{ 'Enter code from email' | translate }}"
                                                        name="newEmailCode"
                                                        [(ngModel)]="newEmailCode"
                                                        required />
                                                </div>
                                                <button
                                                    type="submit"
                                                    class="btn"
                                                    (click)="confirmEmail()"
                                                    [disabled]="isAddingNewEmail">
                                                    {{ 'Verify' | translate }}
                                                </button>
                                            </form>
                                        }
                                        @if (request.authUserInfo.emails.length) {
                                            <div class="mt-3">
                                                @for (emailItem of request.authUserInfo.emails; track emailItem) {
                                                    <div class="mb-2">
                                                        <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                        {{ emailItem.email }}
                                                        <em>
                                                            {{ 'verified' | translate }}
                                                        </em>
                                                        <a
                                                            class="text-danger ms-2"
                                                            href="javascript:void(0);"
                                                            (click)="removeEmail(emailItem)">
                                                            {{ 'remove' | translate }}
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </li>

                            <li>
                                <label for="contactEmail">{{
                                    'Enter the email address you want your data sent to:' | translate
                                }}</label>
                                <div [hidden]="request.contactAddress.email && request.contactAddress.isVerified">
                                    <form
                                        class="d-flex align-items-baseline m-flex-column mt-3"
                                        #contactEmailForm="ngForm">
                                        <div class="form-group mb-2 ms-0 me-3">
                                            <input
                                                [ngClass]="{
                                                    invalid: isFormSubmitted && !request.contactAddress.email,
                                                }"
                                                type="email"
                                                class="form-control"
                                                #contactEmailModel="ngModel"
                                                id="contactEmail"
                                                placeholder="{{ 'Enter your email' | translate }}"
                                                name="contactEmail"
                                                [(ngModel)]="request.contactAddress.email"
                                                required
                                                email />
                                        </div>
                                        <button
                                            type="submit"
                                            class="btn"
                                            [disabled]="!contactEmailForm.form.valid"
                                            (click)="addContactEmail()"
                                            [disabled]="isAddingContactEmail">
                                            {{ 'Send code' | translate }}
                                        </button>
                                    </form>

                                    @if (request.contactAddress.email && isContactEmailAdded) {
                                        <form class="d-flex align-items-baseline m-flex-column">
                                            <div class="form-group d-flex mt-2 mb-2 ms-0 me-3">
                                                <input
                                                    [ngClass]="{
                                                        invalid: isFormSubmitted && !request.contactAddress.isVerified,
                                                    }"
                                                    autocomplete="off"
                                                    type="text"
                                                    class="form-control"
                                                    id="contactEmailCode"
                                                    placeholder="{{ 'Enter code from email' | translate }}"
                                                    name="contactEmailCode"
                                                    [(ngModel)]="contactEmailCode"
                                                    required />
                                            </div>
                                            <button
                                                type="submit"
                                                class="btn"
                                                (click)="confirmContactEmail()"
                                                [disabled]="isAddingContactEmail">
                                                {{ 'Verify' | translate }}
                                            </button>
                                        </form>
                                    }
                                </div>

                                @if (request.contactAddress.email && request.contactAddress.isVerified) {
                                    <div class="mb-2">
                                        <i class="fa fa-check text-success" aria-hidden="true"></i>
                                        {{ request.contactAddress.email }}
                                        <em>
                                            {{ 'verified' | translate }}
                                        </em>
                                    </div>
                                }
                            </li>

                            <li>
                                {{ "Send the request. You'll hear back from" | translate }}
                                {{ portal.communityDisplayName }}
                                {{ "within 30 days. You'll receive a copy of this request by email." | translate }}
                                <div>
                                    <button
                                        class="btn btn-success mt-3"
                                        (click)="submitRequest()"
                                        [disabled]="isSubmitButtonDisabled()">
                                        {{ 'Submit my request' | translate }}
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                }
            </div>

            @if (isRequestSubmitted || request.authUserInfo.isAuthDataSubmitted) {
                <div class="pt-5">
                    <h4 class="text-center">
                        {{ 'Well done!' | translate }}
                    </h4>
                    @if (portal.receipt) {
                        <p [innerHTML]="portal.receipt" class="text-center"></p>
                    } @else {
                        <p class="text-center">
                            {{ 'Your data is being collected and sent to' | translate }}
                            {{ portal.communityDisplayName }}
                            {{ '(the data controller).' | translate }}
                        </p>
                    }
                </div>
            }
        </div>
    </main>
</div>
